import { render } from "./VEmpty.vue?vue&type=template&id=790e74fb&scoped=true"
import script from "./VEmpty.vue?vue&type=script&lang=js"
export * from "./VEmpty.vue?vue&type=script&lang=js"

import "./VEmpty.vue?vue&type=style&index=0&id=790e74fb&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-790e74fb"]])

export default __exports__